import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getToken } from "./utils/authUtils";


const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Get the logged-in user from cookies or localStorage
    const cookies = document.cookie.split("; ");
    const loggedInUserCookie = cookies.find(cookie =>
      cookie.startsWith("loggedInUser=")
    );
    const loggedInUser = loggedInUserCookie
      ? loggedInUserCookie.split("=")[1]
      : localStorage.getItem("loggedInUser");

    // Check if token exists
    const token = getToken();

    // If there's no logged-in user or token, redirect to login page
    if (!loggedInUser || !token) {
      // console.log("No loggedInUser or token found. Redirecting to login.");
      navigate("/login");
    }
  }, [navigate]);

  return <>{children}</>; // Render the children (protected content) if logged in and token exists
};

export default PrivateRoute;
